import project1 from ".././assets/project01.png";
import project4 from "../assets/project3.png";
import restaurantAppImg from "../assets/restaurant-app.jpg";
import carRentalAppImg from "../assets/car-rental-app.png";
import eventRegAppImg from "../assets/event-registration-app.jpg";
import quizAppImg from "../assets/quiz-app.png";
import techLpImg from "../assets/tech-lp3.png";
import realEstateImg from "../assets/real-estate.png";

// restaurant app, event registration, car rental app, furniture app, chat app, quiz app, social media dashboard, tech LP, furniture LP

export const projects = [
  {
    id: 1,
    name: "Restaurant Application",
    description:
      "Developed a fully functional food ordering web app using the MERN Stack. Implemented user authentication, product filtering and shopping cart features and styled application using React Bootstrap",
    websiteUrl: "https://github.com/Shobby789/restaurant-application.git",
    image: restaurantAppImg,
  },
  {
    id: 2,
    name: "Furniture Application",
    description:
      "Developed an app for Furniture Store using React and Redux toolkit, Implemented product catalog shopping cart features, placing order and styled this application using Bootstrap.",
    websiteUrl: "https://neon-rolypoly-2a4160.netlify.app/",
    image: project1,
  },
  {
    id: 3,
    name: "Car Rental Application (under development)",
    description:
      "This is car rental web application created using React JS, in this app a user can see all available cars and take a car of their choice on rent for a time period they want.",
    websiteUrl: "https://car-rental-website-two.vercel.app/",
    image: carRentalAppImg,
  },
  {
    id: 4,
    name: "Event Registration Application",
    description:
      "Developed fully functional Event Registration app using MERN stack. Implemented user authentication, Event creation, registration in an event and styled this app using React Bootstrap.",
    websiteUrl: "https://github.com/Shobby789/event-registration-app.git",
    image: eventRegAppImg,
  },
  {
    id: 11,
    name: "Real Estate Website",
    description:
      "Welcome to Modern Realty Showcase, a cutting-edge web application designed to redefine your real estate experience. Developed with React.js and styled with a touch of creativity through custom CSS.",
    websiteUrl: "https://reactjs-real-estate-app.netlify.app/",
    image: realEstateImg,
  },
  {
    id: 5,
    name: "Quiz Application",
    description:
      "This is a very simple quiz application created using React JS and React Bootstrap, where a user can see all available quizes, start any quiz and all the results will be calculated and shown at the end.",
    websiteUrl: "https://lucent-frangollo-a44335.netlify.app/",
    image: quizAppImg,
  },
  {
    id: 6,
    name: "Bootstrap LP",
    description:
      "This is landing page for a tech company, created using React JS and Bootstrap. A user can see and filter the company projects and see all their details of the company.",
    websiteUrl: "https://guileless-banoffee-fc2799.netlify.app/",
    image: techLpImg,
  },
  {
    id: 7,
    name: "Bootstrap LP",
    description:
      "This is landing page for a Furniture store, it is created using HTML, CSS and Bootstrap, and it is responsive fit into all devices.",
    websiteUrl: "https://jazzy-truffle-a787f7.netlify.app/",
    image: project4,
  },
];

// shopping website
// https://tiny-syrniki-395640.netlify.app/
